// Vinnuvélar are tool groups of the "HeavyMachinery" type. ToolGroupTypes ids are pinned by
// migration AddHeavyMachineryToolGroupType: 1 = Car, 2 = Tool Groups, 3 = HeavyMachinery.
export const HEAVY_MACHINERY_TOOL_GROUP_TYPE_ID = 3;

// Each recorded inspection is a "machineInspection{guid}" property holding "yyyy-MM-dd|comment",
// where the date is the NEXT inspection due. The latest of those dates is the upcoming one.
export const INSPECTION_PROPERTY_PREFIX = 'machineInspection';

export function inspectionsFromProperties(toolGroupProperties) {
  if (!toolGroupProperties) return [];
  return toolGroupProperties
    .filter(p => p.key.startsWith(INSPECTION_PROPERTY_PREFIX))
    .map(p => {
      const [date, comment] = p.value.split('|');
      return { date, comment: comment || '' };
    })
    .filter(i => !isNaN(new Date(i.date)))
    .sort((a, b) => new Date(b.date) - new Date(a.date));
}

export function nextInspectionFromProperties(toolGroupProperties) {
  const inspections = inspectionsFromProperties(toolGroupProperties);
  return inspections.length > 0 ? inspections[0].date : '';
}

export function formatInspectionDate(isoDate) {
  if (!isoDate) return '';
  const parsed = new Date(isoDate);
  if (isNaN(parsed)) return '';
  return parsed.toLocaleDateString('en-GB', { day: '2-digit', month: '2-digit', year: 'numeric' });
}
